module.exports = __webpack_public_path__ + "img/cloud2.829d613b.png";